import { render, staticRenderFns } from "./NationalPhysicalStandards.vue?vue&type=template&id=73a70504&scoped=true&"
import script from "./NationalPhysicalStandards.vue?vue&type=script&lang=js&"
export * from "./NationalPhysicalStandards.vue?vue&type=script&lang=js&"
import style0 from "./NationalPhysicalStandards.vue?vue&type=style&index=0&id=73a70504&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a70504",
  null
  
)

export default component.exports